import { useT } from '../i18n';

interface HomeProps {
  onSeeWorks: () => void;
}

export default function Home({ onSeeWorks }: HomeProps) {
  const t = useT();
  return (
    <section className="max-w-4xl rounded-xl border border-neutral-200 bg-white p-8 shadow-soft transition-shadow duration-200 hover:shadow-float md:p-12">
      <div className="flex flex-col gap-6 max-w-3xl">
        <p className="text-sm font-mono uppercase tracking-[0.22em] text-coffee">{t('home.kicker')}</p>
        <h1 className="text-5xl md:text-6xl font-semibold leading-tight text-cocoa">
          {t('home.headline')}
        </h1>
        <p className="text-lg text-coffee leading-relaxed">{t('home.paragraph')}</p>
        <div className="flex gap-3 pt-2">
          <button
            type="button"
            onClick={onSeeWorks}
            className="rounded-full bg-tan px-5 py-2.5 font-mono text-sm text-neutral-100 shadow-soft transition hover:-translate-y-0.5 hover:bg-neutral-800 hover:shadow-card focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-neutral-950/15"
          >
            {t('home.cta')}
          </button>
        </div>
      </div>
    </section>
  );
}
